/* Import Modules */
import $ from "jquery";
import axios, { AxiosRequestConfig } from "axios";
import { usersForSinglePulldownByVue } from "../../variables";

/* Define Script */
const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: "/api/grouping_department_user_by_single_pulldown",
    method: "GET",
  };

  return axiosOptions;
};

export const getGroupingDepartmentUserBySingle = async () => {
  let usersArray = {};
  const axiosOptions = await getAxiosOptions();
  await axios(axiosOptions)
    .then(async (result) => {
      await $.each(result.data.data, function (index: any, user: any) {
        if (!usersArray[user.departmentId]) {
          let userTempArray = {
            departmentName: "",
            users: [],
          };
          userTempArray.departmentName = user.departmentName;
          usersArray[user.departmentId] = userTempArray;
        }
        usersArray[user.departmentId].users.push({
          id: user.id,
          name: user.name,
        });
      });

      usersForSinglePulldownByVue.users.push(usersArray);
    })
    .catch((error) => {
      console.log(error);
    });
};
